import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";

export default function AdminChangeCreds() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ current_password: "", new_email: "", new_password: "" });
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.current_password) { toast.error("Enter your current password"); return; }
    if (!form.new_email && !form.new_password) { toast.error("Provide a new email or new password"); return; }
    setBusy(true);
    try {
      const payload = { current_password: form.current_password };
      if (form.new_email) payload.new_email = form.new_email;
      if (form.new_password) payload.new_password = form.new_password;
      await api.post("/admin/change-credentials", payload);
      toast.success("Credentials updated. Please log in again.");
      await logout();
      nav("/secure-admin/login");
    } catch (e2) {
      toast.error(formatApiErrorDetail(e2.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="space-y-6 max-w-lg">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold tracking-tight">Admin Settings</h1>
        <p className="text-muted-foreground text-sm">Change your admin email or password. Current email: <b>{user?.email}</b></p>
      </div>
      <Card className="p-5 sm:p-6 ip-card-shadow">
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label className="mb-1.5 block">Current password</Label>
            <Input type="password" required data-testid="change-current-password" value={form.current_password} onChange={set("current_password")} />
          </div>
          <div>
            <Label className="mb-1.5 block">New email (optional)</Label>
            <Input type="email" data-testid="change-new-email" value={form.new_email} onChange={set("new_email")} placeholder={user?.email} />
          </div>
          <div>
            <Label className="mb-1.5 block">New password (optional)</Label>
            <Input type="password" data-testid="change-new-password" value={form.new_password} onChange={set("new_password")} placeholder="Min 6 characters" />
          </div>
          <Button type="submit" disabled={busy} className="h-11" data-testid="change-creds-submit">
            {busy ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : <Save className="h-4 w-4 mr-2" />} Update Credentials
          </Button>
        </form>
      </Card>
    </div>
  );
}
